export const backgroundConfig = {
    // Customize your mosque photo search
    searchQuery: 'mosque architecture',
    
    // How often to change the background (in milliseconds)
    // Set to 0 to disable auto-changing
    changeInterval: 24 * 60 * 60 * 1000, // 24 hours
    
    // Image quality
    imageSize: 'raw', // 'raw', 'full', 'regular', 'small'
  // Minimum acceptable image resolution (pixels)
  // Images below these values will be retried up to `maxFetchAttempts`
  minWidth: 1600,
  minHeight: 900,
  // How many times to try fetching a suitable image before falling back
  maxFetchAttempts: 3,
    
    // Cache images in localStorage
    enableCache: true,
    
    // Default overlay opacity
    overlayOpacityLight: 0.3,
    overlayOpacityDark: 0.6,
  };
  
  export default backgroundConfig;